import Rendable from '@/glxp/abstract/rendable'
import Skin from '@/glxp/abstract/skin'
import Shader from '@/glxp/utils/shader'
import Node from '@/glxp/abstract/node'

import DebugController from '@/glxp/debug/debugController'
import ShaderManifest from '@/glxp/shaderManifest'
import {vec3} from "gl-matrix"

const COLORS_TEXT = ["Hand_Red", "Hand_Green"]

class Mesh extends Rendable {
    constructor(scene, geom, skinData, source, rootnodeName, nodeTree) {
        super(scene)

        this.gl = scene.gl
        this.scene = scene
        this.geom = geom
        this.skinData = skinData
        this.source = source
        this.nodeTree = nodeTree
        this.rootnodeName = rootnodeName

        this.time = 0
        this.active = true

        this.texture = COLORS_TEXT[0]
        
        this.shader = new Shader(ShaderManifest["skin"])
        this.hasNormal = false
        this.skin = new Skin(this, this.skinData, this.rootnodeName)
        this.preventPost = false
        
        this.createAttribute("aWeights_0", "aWeights_0", 4, this.skin.attribData["weight_0"])
        this.createAttribute("aBoneNdx_0", "aBoneNdx_0", 4, this.skin.attribData["ndx_0"])
        this.createAttribute("aWeights_1", "aWeights_1", 4, this.skin.attribData["weight_1"])
        this.createAttribute("aBoneNdx_1", "aBoneNdx_1", 4, this.skin.attribData["ndx_1"])

        this.initBuffer({
            vertices: this.geom.vertices,
            uvs: this.geom.uvs,
            indices: this.geom.indices
        })

        this.initProgram(this.shader.vert, this.shader.frag)
        this.initVao()
        this.initMatrix()
        this.createUniforms()

    }

    setColor(id){
        this.texture = id
    }

    setRandomColor(){
        this.texture = COLORS_TEXT[Math.floor(Math.random() * (COLORS_TEXT.length - 1)) + 1]
    }

    createUniforms() {
        this.createUniform('uTexture', 'texture')
        this.createUniform("uGrain", "texture")
        this.createUniform('uBones', '[mat4]')
        this.createUniform("uGrainValue")
        this.createUniform("uGrainScale")
    }

    applyState() {
        let gl = this.gl
        this.scene.applyDefaultState()
        gl.enable(gl.CULL_FACE);
        gl.cullFace(gl.BACK);
    }

    preRender() {
        if (!this.active) {
            return
        }
        
        this.time += this.scene.dt * this.speed * 0.001
        let t = this.time

        this.skin.update()
    }

    render() {
        if (!this.active) {
            return
        }

        let gl = this.gl
        gl.useProgram(this.program)
        gl.bindVertexArray(this.vao)
        this.applyState()

        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture(this.texture))
        this.bindUniform('uTexture', 0)
        this.bindMatrixUniforms(this.scene.camera)

        gl.activeTexture(gl.TEXTURE1)
        gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture("Grain"))
        this.bindUniform('uGrain', 1)
        this.bindUniform('uGrainValue', this.scene.config.grainHand.value)
        this.bindUniform('uGrainScale', this.scene.config.grainScaleHand.value)

        this.bindUniform('uBones', this.skin.boneArray)
        
        gl.drawElements(gl.TRIANGLES, this.geom.indices.length, gl.UNSIGNED_SHORT, 0)
        gl.bindVertexArray(null)

        // this.skin.renderDebug()

    }
}

export default Mesh
